export default __webpack_public_path__ + "static/media/ffa74c5bcaf0d849f4878c15939502391581611319383.3c8ff8fd.webp";